module.exports = __webpack_public_path__ + "img/enging_room_pic08.a819e55d.png";